import React from "react";
import {Button} from '@material-ui/core'

const PaginacaoExibirMais = ({ currentPage, pageSize, totalRecords, onLoadMore }) => {
  const totalPages = Math.ceil(totalRecords / pageSize);

  if (currentPage >= totalPages) return null;

  return (
    <div style={{ textAlign: "center", marginTop: 16 }}>
      <Button
        onClick={() => onLoadMore(currentPage + 1, pageSize)}
        className="btn-success"
      >
        Exibir mais
      </Button>
    </div>
  );
};

export default PaginacaoExibirMais;
